import { Gantt, Task, ViewMode } from "gantt-task-react";
import "gantt-task-react/dist/index.css";
import "./gantt.scss";
import { useState } from "react";
import { useTheme } from '@mui/material';

interface GanttDataProps {
  data: Task[];
  showList?: boolean;
  progressChange?: boolean;
  dateChange?: boolean;
}

const GanttChart = (props: GanttDataProps) => {
  const { data, showList, progressChange, dateChange } = props;
  const theme = useTheme();
  const tasks: Task[] = data;
  const [task, setTask] = useState<Task[]>(tasks);

  const taskProgressColor = theme?.palette?.theme?.tertiary6[300];
  const taskBackgroundColor = theme?.palette?.theme?.tertiary6[200];
  const milestoneColor = theme?.palette?.theme?.tertiary4[700];
  const projectProgressColor = theme?.palette?.theme?.tertiary3[400];
  const projectBackgroundColor = theme?.palette?.theme?.tertiary3[300];
  const todayColor = theme?.palette?.theme?.tertiary5[400];

  const handleProgressChange = (updatedTask: Task) => {
    if (progressChange) {
      const taskIndex = tasks.findIndex((task) => task.id === updatedTask.id);

      const updatedTasks = [...tasks];
      updatedTasks[taskIndex] = updatedTask;

      setTask(updatedTasks);
    }
  };

  const handleDateChange = (updatedTask: Task) => {
    if (dateChange) {
      const taskIndex = tasks.findIndex((task) => task.id === updatedTask.id);

      const updatedTasks = [...tasks];
      updatedTasks[taskIndex] = updatedTask;

      setTask(updatedTasks);
    }
  };

  const handleExpanderClick = (clickedTask: Task) => {
    setTask((prevTasks: Task[]) =>
      prevTasks.map((task) =>
        task.id === clickedTask.id ? clickedTask : task,
      ),
    );
  };

  return (
    <Gantt
      tasks={task}
      viewMode={ViewMode.Day}
      listCellWidth={showList ? "190px" : ""}
      columnWidth={80}
      barCornerRadius={8}
      fontSize="12"
      fontFamily="Inter"
      onProgressChange={progressChange ? handleProgressChange : undefined}
      onDateChange={dateChange ? handleDateChange : undefined}
      barProgressColor={taskProgressColor}
      barProgressSelectedColor={taskProgressColor}
      barBackgroundColor={taskBackgroundColor}
      barBackgroundSelectedColor={taskBackgroundColor}
      milestoneBackgroundColor={milestoneColor}
      milestoneBackgroundSelectedColor={milestoneColor}
      projectBackgroundColor={projectBackgroundColor}
      projectBackgroundSelectedColor={projectBackgroundColor}
      projectProgressColor={projectProgressColor}
      projectProgressSelectedColor={projectProgressColor}
      todayColor={todayColor}
      onExpanderClick={handleExpanderClick}
    />
  );
};

export { GanttChart };
export default GanttChart;
